import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { getLocalizedPath } from '../../utils/linkUtils';

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
  language?: string;
}

/**
 * A wrapper around React Router's Link component that automatically
 * adds the current language prefix to the URL.
 */
const LocalizedLink: React.FC<LocalizedLinkProps> = ({ 
  to, 
  language,
  children, 
  ...rest 
}) => {
  const localizedTo = getLocalizedPath(to, language);

  return (
    <Link to={localizedTo} {...rest}>
      {children}
    </Link>
  );
};

export default LocalizedLink; 